import { useRouterWithI18n } from '@ui/locales/browserSSG';
import type { PostHog } from 'posthog-js';
import posthog from 'posthog-js';
import { useEffect } from 'react';

const posthogProjectApiKey = 'phc_oI7Azvlt1qeICIoEQfnqBoihjvKY2DdgbgD5MBHHfe4';

export const useInitializePostHog = () => {
  const router = useRouterWithI18n();
  useEffect(() => {
    const posthog = initPostHog();
    if (posthog === undefined) return;
    const handleRouteChange = () => posthog.capture('$pageview');
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);
};

let postHogSingleton: PostHog | undefined;

const initPostHog = (): PostHog | undefined => {
  if (
    typeof window === 'undefined' ||
    !posthogProjectApiKey ||
    !(process.env.APP_ENV === 'prod' || process.env.APP_ENV === 'sta')
  ) {
    return undefined;
  }
  if (postHogSingleton) return postHogSingleton;
  posthog.init(posthogProjectApiKey, {
    api_host: 'https://app.posthog.com',
    loaded: (posthog) => {
      posthog.register({
        appVersion: process.env.APP_VERSION,
      });
    },
  });
  return (postHogSingleton = posthog);
};
